import Quality from '../components/Quality';
import SocialMedia from '../components/SocialMedia';

export const About = ():JSX.Element => {
  return (
    <>
      <Quality />
      <SocialMedia />
    </>
  );
}
